import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State, orderBy } from '@progress/kendo-data-query';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmDialog } from '../modals/confirm-dialog.component';
import { OrderService } from '../../services/order.service';
import { UtilService } from '../../services/util.service';
import {
    SearchThirdPartyCompany
} from '../../models/models';

@Component({
    selector: 'third-party-company-grid',
    templateUrl: './third-party-company-grid.component.html',
    standalone: false
})
export class ThirdPartyCompanyGrid implements OnInit {
    @ViewChild(GridComponent, { static: false }) public tableGrid!: GridComponent;

    public isEdit: boolean = false;
    public isAdd: boolean = false;

    public tableID: number = 0;
    public recordName: string = "Third Party Company";
    public tableList: SearchThirdPartyCompany[] = [];
    private tableIDName: string = "thirdPartyCompanyID";

    public gridData: GridDataResult = { data: [], total: 0 };
    public gridState: State = { skip: 0, take: 10, sort: [{ dir: 'asc', field: this.tableIDName }] };

    constructor(private orderService: OrderService, private utilService: UtilService, private dialog: MatDialog, private ngZone: NgZone) {
    }

    ngOnInit() {
        this.getTableList();
    }

    private getTableList() {
        this.utilService.isLoading = true;
        this.orderService.getSearchThirdPartyCompanies().subscribe(result => {
            this.utilService.isLoading = false;
            this.tableList = result.resultCollection;
            this.setGrid();
        });
    }

    private setGrid() {
        if (this.gridState.sort) this.tableList = orderBy(this.tableList, this.gridState.sort);

        this.gridData = process(this.tableList, this.gridState);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.tableGrid == null) return;
            this.tableGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent) {
        this.gridState = state;
        this.setGrid();
    }

    public edit(tableID: number) {
        this.tableID = tableID;
        this.isEdit = true;
        this.isAdd = false;
    }

    public delete(tableID: number) {
        var idx = this.tableList.findIndex(c => c.thirdPartyCompanyID == tableID);

        if (idx == null || idx < 0) return;

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            header: 'Delete?',
            message: 'Would you like to delete this ' + this.recordName + '?'
        }

        const dialogRef = this.dialog.open(ConfirmDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(dialogResult => {
            if (!dialogResult) return;
        });
    }

    public addNew() {
        this.tableID = 0;
        this.isEdit = false;
        this.isAdd = true;
    }

    public cancelEdit() {
        this.isEdit = false;
        this.isAdd = false;
        this.getTableList();
    }
}
